import { DocumentClient, Documents, FileResponse } from "@api/apiClient";
import axios from "@api/axiosInstance";
import { useMutation, useQuery } from "@tanstack/react-query";

const documentClient = new DocumentClient(undefined, axios);

export const useDocumentNames = (options?: any) => {
  return useQuery<Documents[]>({
    ...options,
    queryKey: ["documentNames"],
    queryFn: async () => documentClient.getDocuments(),
  });
};

export const useDownloadDocument = (options?: any) => {
  return useMutation<FileResponse>({
    ...options,
    mutationFn: (options: string) => documentClient.downloadDocument(options)
  });
};

export const useCreateDocument = (options?: any) => {
  return useMutation<string>({
    ...options,
    mutationFn: (fileParams: any) => documentClient.uploadDocument(fileParams)
  });
};

export const useDeleteDocument = (options?: any) => {
  return useMutation<string>({
    ...options,
    mutationFn: (options: any) => documentClient.deleteDocument(options)
  });
};